import {Skeleton} from '@mui/material';
import Grid from '@mui/material/Grid2';

export const QuickAccessButtonTemplate = () => (
  <Grid container size={12} display={'flex'} flexDirection={'column'}>
    <Grid container display={'flex'} justifyContent={'space-between'} size={12}>
      {Array.from({length: 5}).map((_, index) => (
        <Grid
          key={index}
          display={'flex'}
          flexDirection={'column'}
          alignItems={'center'}
          width={52}>
          <Skeleton
            variant="rectangular"
            width="52px"
            height="52px"
            sx={{borderRadius: '0.75rem'}}
          />
          <Skeleton sx={{mt: '4px'}} variant="text" width="80%" height="15px" />
        </Grid>
      ))}
    </Grid>
  </Grid>
);
